import React, { useEffect } from 'react';
import AutoLogoutConnected from '../AutoLogout/AutoLogoutConnected';
import KeepAliveConnected from '../KeepAlive/KeepAliveConnected';
import withRedux from '../../../withRedux';
import cookieUtils from '../../../lib/cookieUtils';
import { connect } from 'react-redux';
import { hasActiveSession } from '../../../store/appState/appState.selectors';
import RootDialog from '../../Communications/Dialog/RootDialog';
import { getProfileData } from '../../../store/ciam/ciam.selectors';
import { fetchProfileData } from '../../../store/ciam/ciam.actions';
import { confirmLogoutClickAction } from '../../../store/session';

interface Props {
  children?: (
    hasActiveSession: boolean,
    profileData: Record<string, unknown> | null,
    logout: (...args: unknown[]) => unknown
  ) => React.ReactNode;
  hasActiveSession?: boolean;
  profileData?: Record<string, unknown> | null;
  fetchProfileData?: (...args: unknown[]) => unknown;
  logout?: (...args: unknown[]) => unknown;
}

const SessionWrapper = ({
  children,
  hasActiveSession,
  profileData,
  fetchProfileData,
  logout,
}: Props) => {
  const targetType = import.meta.env.REACT_APP_PROXY_TARGET_TYPE;
  if (targetType === 'JSON_SERVER') {
    cookieUtils.createMockCsrfCookies();
  }

  useEffect(() => {
    // console.log('hasActiveSession', hasActiveSession);
    if (hasActiveSession) fetchProfileData();
  }, [hasActiveSession, fetchProfileData]);

  const isReady =
    hasActiveSession === false ||
    (hasActiveSession === true && profileData !== null);

  return (
    <>
      <RootDialog />
      {isReady && children(hasActiveSession, profileData, logout)}
      <AutoLogoutConnected />
      <KeepAliveConnected autoRedirect={false} />
    </>
  );
};

const mapStateToProps = (state) => ({
  hasActiveSession: hasActiveSession(state),
  profileData: getProfileData(state),
});

const mapDispatchToProps = {
  fetchProfileData,
  logout: confirmLogoutClickAction,
};

export default withRedux(
  connect(mapStateToProps, mapDispatchToProps)(SessionWrapper)
);
